export const environment = {
  production: true,
  apiUrl: 'https://api-staging-dashboard.tendenciasab.com/api',
  storageToken: 'token-key',
};
